import LoginPrompt from './container';

export default LoginPrompt;



// WEBPACK FOOTER //
// ./app/src/components/LoginPrompt/index.js